module.exports = __webpack_public_path__ + "img/video106.808afc08.jpg";